module.exports = __webpack_public_path__ + "51832492a75da66b9ba904e26664de6c.png";